













import { computed, defineComponent, getCurrentInstance, reactive } from '@vue/composition-api';
import i18n, { i18n_t } from '@/locales/i18n';
interface ShowController {
  menu: boolean;
  subMenu: 'teamSpace' | string;
}
export function MenuHandler() {
  const showController = reactive<ShowController>({
    menu: false,
    subMenu: '',
  });
  const methods = {
    openMenu(subMenu?: 'teamSpace' | string) {
      if (subMenu) {
        showController.menu = false;
        showController.subMenu = subMenu;
      } else {
        showController.menu = true;
        showController.subMenu = '';
      }
    },
    closeMenu() {
      showController.menu = false;
      showController.subMenu = '';
    },
  };
  return {
    showController,
    methods,
  };
}
export default defineComponent({
  setup(props, context) {
    const vm = getCurrentInstance()?.proxy || context.root;
    const editionFlag = computed(() => vm.$store.getters.editionFlag);
    const menuList = computed(() => [
      {
        title: i18n_t('最近使用'),
        route: 'recentUse',
        icon: 'menu-recent-use',
      },
      {
        title: i18n_t('我的收藏'),
        route: 'myFavorite',
        icon: 'menu-my-favorite',
      },
      {
        title: i18n_t('协作空间'),
        route: 'collaborationSpace',
        icon: 'menu-collaboration-space',
        // hasOperate: true,
      },
      {
        title: i18n_t('企业空间'),
        route: 'teamSpace',
        icon: 'menu-team-space',
        isHidden: editionFlag.value === 'personal' || vm.$store.getters.userBaseInfo.isTemporary,
        hasOperate: true,
      },
      {
        title: i18n_t('个人空间'),
        route: 'personalSpace',
        icon: 'menu-personal-space',
        isHidden: !vm.$store.getters.hasPersonalSpace || vm.$store.getters.userBaseInfo.isTemporary,
      },
      {
        title: i18n_t('安全外链'),
        route: 'linkManage',
        icon: 'menu-link-manage',
      },
    ]);
    return {
      menuList,
    };
  },
});
